import { attr, belongsTo } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validateNumber,
  validatePresence
} from "ember-changeset-validations/validators";
import type IntlService from "ember-intl/services/intl";
import JournalEvent from "parog-web/models/journal-event";
import type Patient from "parog-web/models/patient";
import type PredictorExplainer from "parog-web/models/predictor/predictor-explainer";
import tWithDefault from "parog-web/utils/t-with-default";

//---- Automatically generated, don't update this part ----

export default class AdherencePredictionComputedJournalEvent extends JournalEvent {
  static type = "adherence-prediction-computed-journal-event";

  @attr("number") declare observanceScore: number;

  @attr("string") declare observanceModelDescription: string;

  /**
   * a string in french representing the category of the observance score
   */
  @attr("string") declare observanceScoreCategory: string;

  @attr("number") declare persistenceScore: number;

  @attr("string") declare persistenceModelDescription: string;

  /**
   * a string in french representing the category of the persistence score
   */
  @attr("string") declare persistenceScoreCategory: string;

  /**
   * the average score category between persistence score category and obdervance score category
   */
  @attr("string") declare averageScoreCategory: string;

  /**
   * a string in french representing the warnings returned by the Predictor
   */
  @attr("string") declare warnings: string;

  static validations(intl: IntlService) {
    return {
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.adherence-prediction-computed-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ],
      observanceScore: validateNumber({
        allowBlank: true,
        description: intl.t(
          "validations.adherence-prediction-computed-journal-event.observance-score"
        )
      }),
      persistenceScore: validateNumber({
        allowBlank: true,
        description: intl.t(
          "validations.adherence-prediction-computed-journal-event.persistence-score"
        )
      })
    };
  }

  //---- End of generated code ----

  @belongsTo("patient", {
    async: false,
    inverse: "adherencePredictionComputedJournalEvent"
  })
  declare patient: Patient;

  @attr("predictor-explainers")
  declare observanceExplainers: PredictorExplainer[];

  @attr("predictor-explainers")
  declare persistenceExplainers: PredictorExplainer[];
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "adherence-prediction-computed-journal-event": AdherencePredictionComputedJournalEvent;
  }
}
